import React from 'react';
import {Document, Page, View} from '@react-pdf/renderer';
import styles, {getDepotsWithNoResults, getActiveReportFilters} from '../../Foundations/Utils/PDFUtils'
import {IResultsData, IResultSummary} from '../../Foundations/Types/IResultsData';
import ReportHeader from './ReportHeader';
import ReportSummary from './ReportSummary';
import ReportResults from './ReportResults';
import {ISearchFilterSet} from '../../Foundations/Types/ISearchFilter';
import {IGenericObject, IGenericStringArrayObject} from '../../Foundations/Types/IGenericObject';
import {getFiltersSummary} from '../../Foundations/Utils/SearchFilterUtils';
import {IBaseSearchParam} from '../../Foundations/Types/ISearchParam';
import DepotSummary from './DepotSummary';
import {IDepotInfo, IDepotSummary} from '../../Foundations/Types/IDepot';
import {ActiveReportFilters} from '../../Foundations/Enum/ActiveReportFilters';
import ReportFooter from './ReportFooter';
import AboutPage from './AboutPage';
import AncillaryPricing from './AncillaryPricing';
import { ExcessReductionProductsPage1 } from './ExcessReductionProducts';

interface IProps {
    results: IResultsData[];
    activeFilters: ISearchFilterSet | null;
    availableFilters: ISearchFilterSet | null;
    searchParameters: IBaseSearchParam | null;
    searchRef: string;
    resultSummary: IResultSummary;
    mapSnapShot: string;
    selectedFilter: IGenericObject | null;
    depotsAtArea: IDepotInfo[];
    suppliersAtArea: string[];
    radius: number;
}

const ResultReportContainer: React.FC<IProps> = (props) => {
    const filterSummary: IGenericStringArrayObject | null = getFiltersSummary(props.activeFilters, props.availableFilters);
    const depotsWithNoResults: IDepotSummary[] = getDepotsWithNoResults(props.depotsAtArea, props.resultSummary.depotSummary, props.radius);
    const activeReportFilters: ActiveReportFilters[] = getActiveReportFilters(props.activeFilters);

    return (
        <Document keywords={JSON.stringify({ reference: props.searchRef, filter: props.selectedFilter})}>
            <Page size="A4" style={styles.page}>
                <View>
                    <ReportHeader searchRef={props.searchRef} />
                    {
                        props.searchParameters !== null &&
                        (
                            <ReportSummary
                                searchParameters={props.searchParameters}
                                availableFilters={props.availableFilters}
                                activeFilters={props.activeFilters}
                                resultSummary={props.resultSummary}
                                filtersSummary={filterSummary}
                                searchRef={props.searchRef}
                                suppliersAtArea={props.suppliersAtArea}
                                depotsAtArea={props.depotsAtArea}
                                activeReportFilters={activeReportFilters}
                                depotsWithNoResults={depotsWithNoResults}
                            />
                        )
                    }
                </View>
                <ReportFooter />
            </Page>
            <Page size="A4" style={styles.page} wrap>
                <DepotSummary
                    availableFilters={props.availableFilters}
                    totalAvailableCars={props.results.length}
                    resultSummary={props.resultSummary}
                    mapSnapShot={props.mapSnapShot}
                    filterSummary={filterSummary}
                    suppliersAtArea={props.suppliersAtArea}
                    depotsWithNoResults={depotsWithNoResults}
                    activeReportFilters={activeReportFilters}
                    depotsAtArea={props.depotsAtArea}
                />
                <ReportFooter />
            </Page>
            <Page size="A4" style={styles.page} wrap>
                <ReportResults
                    results={props.results}
                    depotsAtArea={props.depotsAtArea}
                    resultSummary={props.resultSummary}
                />
                <ReportFooter />
            </Page>
            <Page size="A4" style={styles.page}>
                <AncillaryPricing />
                <ReportFooter />
            </Page>
            <Page size="A4" style={styles.page}>
                <ExcessReductionProductsPage1 />
                <ReportFooter />
            </Page>
            <Page size="A4" style={styles.page}>
                <AboutPage />
                <ReportFooter />
            </Page>
        </Document>

    )
}

export default ResultReportContainer;
